module.exports = __webpack_public_path__ + "media/crosses/red-cross-e5e8e3e6.svg";